'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var Form_Context = require('../Form.Context/Form.Context.js');

const defaultValues = {
    options: undefined
};
/**
 * Create form options context.
 */ const FormOptionsContext = /*#__PURE__*/ react.createContext([
    {
        ...defaultValues
    },
    {
        getLabelSuffix: ()=>undefined
    }
]);
/**
 * Form Options Context Provider.
 */ const FormOptionsProvider = ({ children, options })=>{
    const { locale } = react.useContext(Form_Context.FormContext);
    // Get the form field label suffix
    const getLabelSuffix = react.useCallback((required)=>{
        if (required && options?.showRequiredIndicators) {
            return locale?.requiredIndicator;
        } else if (!required && options?.showOptionalIndicators) {
            return locale?.optionalIndicator;
        }
    }, [
        locale,
        options
    ]);
    // Memorize values
    const state = react.useMemo(()=>({
            options
        }), [
        options
    ]);
    const actions = react.useMemo(()=>({
            getLabelSuffix
        }), [
        getLabelSuffix
    ]);
    return jsxRuntime.jsx(FormOptionsContext.Provider, {
        value: [
            state,
            actions
        ],
        children: children
    });
};

exports.FormOptionsContext = FormOptionsContext;
exports.FormOptionsProvider = FormOptionsProvider;
//# sourceMappingURL=Form.OptionsContext.js.map
